import { Button } from '@mui/material';
import FormProvider from '@Components/hook-form';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';

import { useCreateLocalizationKeyForm } from '@Forms/localizations/CreateLocalizationKeyFormContext';
import { useLocalization } from '@Modal/hooks/localization/useLocalization';
import { CreateLocalizationKeyContent } from './CreateLocalizationKeyContent';

export const CreateLocalizationKeyForm = () => {
  const methods = useCreateLocalizationKeyForm();
  const { handleCreateLocalizationKeyDialog, submittable, handleSubmitCreateLocalizationKey } =
    useLocalization();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateLocalizationKeyContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => handleCreateLocalizationKeyDialog(false)}
            >
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateLocalizationKey}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
